/**
 * Concatena clases descartando lo que no sea una cadena con contenido.
 *
 * Doce líneas en vez de `clsx`: lo único que hace falta de esa librería es
 * ignorar `false`, `undefined` y `''`, que es exactamente lo que produce un
 * ternario dentro de un `className`.
 *
 * No resuelve conflictos entre utilidades —para eso haría falta
 * `tailwind-merge`, que sí pesa— así que la regla es que la clase que llega por
 * `className` va SIEMPRE la última: en Tailwind gana la que aparece después en
 * la hoja de estilos, no la última del atributo, pero en la práctica escribir
 * el override al final evita el 95 % de las sorpresas. Cuando un primitivo
 * necesite variar de verdad, se le añade una variante en vez de pelearse con
 * las clases desde fuera.
 */
export type ClassValue = string | false | null | undefined

export function cx(...values: ClassValue[]): string {
  return values.filter((value): value is string => typeof value === 'string' && value !== '').join(' ')
}
